import GError from "./GError"

export default abstract class Rows<KEY,ROW> {
    private _ids:Record<string,ROW> = {}
    private _list:ROW[]
    constructor(rows:ROW[]){
        this._list = this.sort(rows)
        for(const row of this._list){
            this._ids[this.serializeKey(this.rowKey(row))] = row
        }
    }
    get items(){return this._list}

    abstract rowKey(row:ROW) : KEY
    cmpkey(key1:KEY, key2:KEY) { return key1===key2}
    sort(list:ROW[]) { return list }

    serializeKey(key:KEY) : string { return key as string }
    deserializeKey(key:string) : KEY { return key as KEY }

    find(key:KEY, silent?:boolean) {
        const row = this._ids[this.serializeKey(key)]
        if (row) return row
        else if (silent) return null
        else throw new GError.NotFound(`Recipe ${key} not found`)
    }
    update(row:ROW){
        const key = this.rowKey(row), strKey = this.serializeKey(key)
        const index = this._list.findIndex(row => this.cmpkey(this.rowKey(row), key))
        if (index<0) this._list.push(row)
        else this._list[index] = row
        this._ids[strKey] = row
        this.sort(this._list)
        return this
    }
    deleteKey(key:KEY){
        const strKey = this.serializeKey(key)
        const index = this._list.findIndex(row => this.cmpkey(this.rowKey(row), key))
        if (index>=0) {
            this._list.splice(index, 1)
            delete this._ids[strKey]
        }
        return this
    }
}